import { render, staticRenderFns } from "./ExampleRegex.vue?vue&type=template&id=89938c16&scoped=true&"
import script from "./ExampleRegex.vue?vue&type=script&lang=js&"
export * from "./ExampleRegex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89938c16",
  null
  
)

export default component.exports